import { atom } from 'recoil';

export const redirectUrl = atom<string>({ key: 'redirectUrl', default: '' });

interface userProps {
    userId         : string;
    userNm         : string;
    pswd           : string; // 비밀번호
    emlAddr        : string; // 이메일주소
    telno          : string; // 휴대폰 번호
    upOgnzCd       : string; // 상위조직코드
    upOgnzNm       : string; // 상위조직명(본부)
    ognzCd         : string; // 조직코드
    ognzNm         : string; // 조직명(지부)
    jbpsSeCd       : string; // 직위구분코드
    jbpsSeNm       : string; // 직위명
    joinSttsCd     : string; // 회원상태코드
    joinSttsNm     : string; // 회원상태명
    budgetAdmin    : string; // 조합비 관리자
    budgetApprover : string; // 조합비 결재자
    budgetViewer   : string; // 조합비 조회
    memberAdmin    : string; // 조합원 관리자
    memberApprover : string; // 조합원 결재자
    memberViewer   : string; // 조합원 조회
    headOfficeAdmin: string; // 본부 관리자
    systemAdmin    : string; // 시스템 관리자
    initPass       : string; // 비밀번호 초기화 여부
    sysAuthrtA1Yn  : string; // 총괄조합비 시스템
    sysAuthrtB1Yn  : string; // 운영비 시스템
    sysAuthrtC1Yn  : string; // 복지기금 시스템
    sysAuthrtC2Yn  : string; // 자립기금 시스템
    sysAuthrtC3Yn  : string; // 발전기금 시스템
    sysAuthrtC4Yn  : string; // 회생자부조금 시스템
    sysAuthrtC5Yn  : string; // 퇴직급여충당금 시스템
    sysAuthrtD1Yn  : string; // 조합원 시스템
    sysAuthrtE1Yn  : string; // 지부 운영비 시스템
    sysAuthrtF1Yn  : string; // 지부장 직무활동비 시스템
    sysAuthrtG1Yn  : string; // 지부 대회비 시스템

    sysEvdncA1Yn   : string; // 총괄교부금        증빙첨부 사용 여부
    sysEvdncB1Yn   : string; // 운영비            증빙첨부 사용 여부
    sysEvdncC1Yn   : string; // 복지기금          증빙첨부 사용 여부
    sysEvdncC2Yn   : string; // 자립기금          증빙첨부 사용 여부
    sysEvdncC3Yn   : string; // 발전기금          증빙첨부 사용 여부
    sysEvdncC4Yn   : string; // 회생자부조금      증빙첨부 사용 여부
    sysEvdncC5Yn   : string; // 퇴직급여충당금    증빙첨부 사용 여부
    sysEvdncD1Yn   : string; // 조합원            증빙첨부 사용 여부
    sysEvdncE1Yn   : string; // 지부 운영비       증빙첨부 사용 여부
    sysEvdncF1Yn   : string; // 지부장 직무활동비 증빙첨부 사용 여부
    sysEvdncG1Yn   : string; // 지부 대화비       증빙첨부 사용 여부
}
export const userInfo = atom<userProps>({ key: 'userInfo', default: {} as userProps });